import { useTranslation } from 'react-i18next'
import { useQueryClient } from 'react-query'

import * as Icons from 'assets/svg/sprite'
import { addToast } from 'components/Toast/Toast'
import { ActionCard } from 'components-ref/molecules/ActionCard/ActionCard'
import { howMuchDaysAgo } from 'helpers/date/how-much-days-ago'
import { type IComment } from 'pages/support/pages/Tickets/types/interfaces/ITicket'
import { useDeleteComment } from 'pages/support/service/react-query/useDeleteComment/useDeleteComment'
import { useUserProfile } from 'store'

import {
    StyledAttachImage,
    StyledAttachInfo,
    StyledAttachmentsWrapper,
    StyledBottomArea,
    StyledBottomAreaBorder,
    StyledBottomAreaDetails,
    StyledBottomAreaDetailsLeft,
    StyledBottomAreaText,
    StyledDateText
} from './TicketComment.styled'

interface ITicketCommentProps {
    ticketId: string
    comment: IComment

    agentData?: {
        id: number | null
        name: string | null
        avatar: string | null
    }
}

export const TicketComment = ({
    ticketId,
    comment,
    agentData
}: ITicketCommentProps) => {
    const { t } = useTranslation()
    const queryClient = useQueryClient()
    const userData = useUserProfile()

    const {
        mutate: deleteCommentMutation,
        isLoading: isDeleting
    } = useDeleteComment()

    const isAgent =
        agentData?.id !== null &&
        agentData?.id !== undefined &&
        comment.author_id === agentData.id

    const isOwnComment =
        comment.author_id === userData?.id

        console.log('author id',comment.author_id)
        console.log('userdata id', userData?.id)

    const icon: string | undefined =
        isAgent
            ? agentData?.avatar || undefined
            : userData?.avatar?.url || undefined

    const displayName = isAgent
        ? agentData?.name ?? 'Support'
        : userData?.display_name ??
          userData?.name ??
          userData?.username ??
          'You'

    const handleDeleteComment = () => {
        if (
            !isOwnComment ||
            isDeleting
        ) {
            return
        }

        deleteCommentMutation(
            {
                ticketId,
                commentId: comment.id
            },
            {
                onSuccess: () => {
                    queryClient.invalidateQueries([
                        'ticketDetails',
                        ticketId
                    ])

                    queryClient.invalidateQueries(
                        'tickets'
                    )
                },

                onError: () => {
                    addToast(
                        'error',
                        t('errorSomethingWentWrong')
                    )
                }
            }
        )
    }

    return (
        <ActionCard
            avatar={icon}
            text={displayName}
            subtext={
                <StyledDateText>
                    {howMuchDaysAgo(
                        comment.created_at
                    )}
                </StyledDateText>
            }
            {...(isOwnComment && {
                trashFn: handleDeleteComment
            })}
            bottomArea={
                <StyledBottomArea>
                    <StyledBottomAreaText>
                        {comment.body}
                    </StyledBottomAreaText>

                    {comment.attachments?.length >
                    0 ? (
                        <>
                            <StyledBottomAreaBorder />

                            <StyledBottomAreaDetails>
                                <StyledBottomAreaDetailsLeft>
                                    <StyledAttachInfo>
                                        <Icons.IconAttach />

                                        <span>
                                            {
                                                comment
                                                    .attachments
                                                    .length
                                            }
                                        </span>
                                    </StyledAttachInfo>
                                </StyledBottomAreaDetailsLeft>
                            </StyledBottomAreaDetails>
                        </>
                    ) : null}

                    <StyledAttachmentsWrapper>
                        {comment.attachments?.map(
                            attachment => (
                                <StyledAttachImage
                                    key={
                                        attachment.id
                                    }
                                    src={
                                        attachment.content_url
                                    }
                                />
                            )
                        )}
                    </StyledAttachmentsWrapper>
                </StyledBottomArea>
            }
        />
    )
}